import React from 'react';
import { X } from '@phosphor-icons/react';
import { backdropClick, stopBackdropPropagation } from '../../lib/modalBackdrop';

export default function LeadPreviewModal({ previewHtml, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" {...backdropClick(onClose)}>
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl h-[90vh] flex flex-col" {...stopBackdropPropagation} data-testid="preview-modal">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="font-bold text-slate-900">Anteprima Contratto</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600"><X size={20} /></button>
        </div>
        <iframe srcDoc={previewHtml} className="flex-1 w-full" title="Anteprima Contratto" />
      </div>
    </div>
  );
}
